const topics = [
  { icon: 'ri-tv-2-line', title: '热播电视剧', count: '2,836部', desc: '国产剧、港台剧、海外剧一网打尽' },
  { icon: 'ri-film-line', title: '院线大片', count: '5,120部', desc: '最新上映与经典佳作随时畅享' },
  { icon: 'ri-emotion-laugh-line', title: '热门综艺', count: '1,458部', desc: '搞笑、竞技、真人秀精彩不断' },
  { icon: 'ri-ghost-line', title: '动漫番剧', count: '3,672部', desc: '日漫国漫人气作品同步追更' },
  { icon: 'ri-treasure-map-line', title: '悬疑推理', count: '892部', desc: '烧脑剧情让你欲罢不能' },
  { icon: 'ri-heart-pulse-line', title: '都市情感', count: '1,264部', desc: '甜蜜爱恋与职场人生百态' },
  { icon: 'ri-sword-line', title: '古装武侠', count: '1,056部', desc: '刀光剑影中的江湖传奇故事' },
  { icon: 'ri-rocket-line', title: '科幻动作', count: '768部', desc: '震撼视效打造极致观影体验' },
];

export default function IndexSection() {
  return (
    <section id="index" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-6xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">专题合集</h2>
        <p className="text-sm text-foreground-500 text-center mb-10 max-w-lg mx-auto">按类型快速找到你想看的内容，海量片源分类整理</p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {topics.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="group flex items-start gap-4 p-5 rounded-2xl bg-background-50 border border-background-200/70 hover:border-primary-200 hover:-translate-y-1 transition-all duration-300 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className="w-11 h-11 flex-shrink-0 flex items-center justify-center rounded-xl bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-300">
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="text-sm font-bold text-foreground-900 mb-1 whitespace-nowrap">{item.title}</h3>
                <p className="text-xs text-foreground-500 leading-relaxed mb-2">{item.desc}</p>
                <span className="text-xs font-medium text-primary-600 whitespace-nowrap">{item.count}</span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}